import { render, staticRenderFns } from "./wonderful-story.vue?vue&type=template&id=0972c18f&scoped=true&"
import script from "./wonderful-story.vue?vue&type=script&lang=js&"
export * from "./wonderful-story.vue?vue&type=script&lang=js&"
import style0 from "./wonderful-story.vue?vue&type=style&index=0&id=0972c18f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0972c18f",
  null
  
)

export default component.exports